import { FC, type JSX } from 'react';

import { Modal } from '@payaca/ambrosia';
import CreateInvoiceControl from '../createInvoiceControl/CreateInvoiceControl';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onCreateInvoiceSuccess?: (invoiceId: number) => void;
  dealId: number;
  defaultToInvoiceValue?: number;
};
const CreateInvoiceModal: FC<Props> = ({
  isOpen,
  onClose,
  onCreateInvoiceSuccess,
  dealId,
  defaultToInvoiceValue,
}: Props): JSX.Element => {
  return (
    <Modal isOpen={isOpen} title={'Create invoice'} onClose={onClose} size="md">
      <CreateInvoiceControl
        defaultToInvoiceValue={defaultToInvoiceValue}
        dealId={dealId}
        onCreateInvoiceSuccess={onCreateInvoiceSuccess}
      />
    </Modal>
  );
};
export default CreateInvoiceModal;
